import React from 'react';

/**
 * Handles a state that needs to be persisted across any component by storing it in local storage
 * If you need any more dates to run through this function make sure to add them to the key checks in the if
 * statements below. Date formats should not be JSON.parsed or JSON.stringify
 *
 * @param defaultValue
 * @param key
 */
const useStickyState = function(defaultValue, key) {
	const [value, setValue] = React.useState(() => {
		const stickyValue = window.localStorage.getItem(key);

		if (key === 'calendarStartDate' || key === 'calendarEndDate') {
			let dateFormat = new Date(stickyValue);

			if (!isNaN(dateFormat) && stickyValue !== null) {
				return dateFormat;
			} else {
				return defaultValue;
			}
		} else {
			return stickyValue !== null && stickyValue !== 'undefined'
				? JSON.parse(stickyValue)
				: defaultValue;
		}
	});

	React.useEffect(() => {
		if (key === 'calendarStartDate' || key === 'calendarEndDate') {
			window.localStorage.setItem(key, value);
		} else {
			window.localStorage.setItem(key, JSON.stringify(value));
		}
	}, [key, value]);

	return [value, setValue];
};

export default useStickyState;
